import React from 'react';

import { AskAiRule } from '@lumapps/ask-ai-rules/types';
import { useClassnames } from '@lumapps/classnames';
import { FlexBox, ProgressCircular } from '@lumapps/lumx/react';

import { AskSearchBestAnswer } from '../../types';
import { AskAiAnswer } from '../AskAiAnswer';
import { AskAiAnswerHeader } from '../AskAiAnswerHeader';

import './index.scss';

export interface AskAiResultContentProps {
    className?: string;
    answer: AskSearchBestAnswer;
    originalQuery: string;
    /** Unique ID to identify each search */
    traceId: string;
    /** Whether the component is used in the micro-apps builder context, only for preview */
    isPreview?: boolean;
    /** Whether the answer is currently being streamed */
    isStreaming?: boolean;
    /** Whether the answer is loading */
    isLoading?: boolean;
    /** Whether Agent name should be displayed */
    shouldDisplayAgentName: boolean;
    /** Handle change agentId */
    handleAgentChange?: (rule: AskAiRule) => void;
}

const CLASSNAME = 'ask-ai-result-content';

/**
 * Display the AI generated result given by the back end.
 */
export const AskAiResultContent: React.FC<AskAiResultContentProps> = ({
    className,
    answer,
    originalQuery,
    traceId,
    isLoading = false,
    isPreview = false,
    isStreaming = false,
    shouldDisplayAgentName = false,
    handleAgentChange,
}) => {
    const { block, element } = useClassnames(CLASSNAME);
    return (
        <FlexBox orientation="vertical" gap="big" className={block(undefined, className)}>
            <AskAiAnswerHeader className={element('query')} originalQuery={originalQuery} />
            <AskAiAnswer
                answer={answer}
                traceId={traceId}
                isPreview={isPreview}
                query={originalQuery}
                isStreaming={isStreaming}
                shouldDisplayAgentName={shouldDisplayAgentName}
                shouldDisplayFooter={!isLoading && !isStreaming}
                handleAgentChange={handleAgentChange}
            />
            {isLoading && <ProgressCircular className={element('loader')} size="xs" />}
        </FlexBox>
    );
};
